__turbopack_context__.v({
  "container": "purchase-card-module-scss-module__HPsbxW__container",
  "item": "purchase-card-module-scss-module__HPsbxW__item",
  "item-icon": "purchase-card-module-scss-module__HPsbxW__item-icon",
  "item-title": "purchase-card-module-scss-module__HPsbxW__item-title",
});
